module.exports = __webpack_public_path__ + "img/kdori.420db0ac.jpg";